import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Spinner animation="grow" variant="primary" />
      <Spinner animation="grow" variant="success" />
      <Spinner animation="grow" variant="danger" />
      <Spinner animation="grow" variant="info" />
    </div>
  );
};
export default Loader;
